<template>
  <div class="login-container">
    <template v-if="status == 0">
      <Loading text="Logging..." />
    </template>
    <template v-else>
      <div class="tips-wrapper">
        <i class="el-icon-warning-outline"></i>
        <template v-if="status == 1">
          <span>
            <p>Login timeout</p>
            <p>
              Please
              <strong class="link-text" @click="getAuthUrl">login</strong> again.
            </p>
          </span>
        </template>
        <template v-else>
          <span>
            <p v-html="tips"></p>
            <p>Please request access from IT administrator.</p>
          </span>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import { RoleCode } from "@/utils/role-constant";
import Loading from "../../components/loading";
import  router from "@/router/index";
export default {
  name: "Authorise",
  components: { Loading },
  data() {
    return {
      status: 0,
      tips: "",
    };
  },
  computed: {
    code() {
      return this.$route.query.code;
    },
    redirectUri() {
      const href = location.href;
      const host = href.substring(0, href.indexOf(this.$route.path));
      return `${host}/authorise`;
    },
  },
  created() {
    if (this.code) {
      this.authCode(this.code);
    } else {
      this.getAuthUrl();
    }
  },
  methods: {
    getAuthUrl() {
      this.axios
        .get("/auth", {
          params: {
            redirectUri: this.redirectUri,
          },
        })
        .then(({ code, data }) => {
          if (code === 200) {
            location.href = data;
          }
        });
    },
    setMetaTitle(_route,title){
      router.options.routes.forEach(route => {
        if(route.path === '/'){
          route.children.forEach(child => {
            if(child.path === _route ){
              child.meta.title = title
            }
          })
        }
      })
    },
    authCode(code) {
      this.axios
        .post("/auth", {
          code: code,
          redirectUri: this.redirectUri,
        })
        .then(({ code, data }) => {
          if (code === 200) {
            this.getMenus(data);
          } else if (code === 403) {
            this.status = 0;
            this.getAuthUrl();
          } else {
            this.status = 2;
            this.tips = `${
              data.email ? `<strong>${data.email}</strong> is` : "You are"
            } not an active account of eMSL.`;
          }
        });
    },
    getMenus(userInfo) {
      const token = userInfo.token;
      delete userInfo.token;
      this.axios
        .get("/sys/menus", {
          headers: {
            Authorization: token,
          },
        })
        .then(({ code, data, msg }) => {
          if (200 === code) {
            if(userInfo.role === RoleCode.VMSL){
              this.setMetaTitle('/se','vCE List')
              this.setMetaTitle('/se/:seId/:mlId','My-vCE-View')
            }
            this.$store.commit("updateState", {
              role: userInfo.role,
              userInfo: userInfo,
              token: token,
              menus: data,
            });
            let redirect = localStorage.getItem("redirect");
            console.log(`[redirect] ${redirect}`)
            redirect = redirect ? redirect.split("#") : null;
            if (redirect && redirect[1] == userInfo.role) {
              this.$router.push(redirect[0]);
            } else if (redirect) {
              this.$router.push(redirect[0]);
            } else {
              if (data[0].subMenus) {
                this.$router.push(data[0].subMenus[0].url);
              } else {
                this.$router.push(data[0].url);
              }
            }
          } else {
            this.$message.error(msg);
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.login-container {
  height: 100vh;
  background: url("../../assets/img/bg.png");
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  .tips-wrapper {
    width: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 2px 10px #999;
    -moz-box-shadow: #999 0 2px 10px;
    -webkit-box-shadow: #999 0 2px 10px;
    border-radius: 4px;
    -moz-border-radius: 4px;
    -webkit-border-radius: 4px;
    i {
      font-size: 2em;
      color: #f56c6c;
    }
    .loading-icon {
      width: 28px;
      height: 28px;
    }
    padding: 20px;
    background: #fff;
    span {
      &:not(.logout-tip) {
        margin-left: 20px;
      }
      p {
        white-space: nowrap;
        line-height: 1.5em;
      }
      &.loading {
        font-weight: bold;
      }
    }
  }
}
</style>
